module.exports = __webpack_public_path__ + "img/xml.5e1c6ece.png";